angular.module('natgeo').controller('Level3BeeScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'UserProgress', 'CommonFunctions', 'SoundEngine',
function Level3BeeScreen($scope, element, ScreenFactory, manager, container, UserProgress, CommonFunctions, SoundEngine)
{
	var screen = ScreenFactory( 'level3_bee', element );
	
	// Gameplay Variables!
	var LevelWidth = 10250;
	var LevelHeight = 470;
	var FlowersPlacedTarget = 20;
	var playing = false;
	var beeLeft = 200;
	var scrollTime = 100;
	var scrollSpeed = LevelWidth / scrollTime;
	var maxTime = scrollTime + (1024 - beeLeft) / scrollSpeed;
	var checkTime = scrollTime + (1024 - beeLeft - 300) / scrollSpeed;
	var checkWindow = {top: 78 + 30, bottom: 207 + 78 - 30};
	var backgroundParralaxAmount = 0.5;
	var markerTravelPercent = 1455;
	var birdOffset = 3;
	var flowerPlacementTries = 10;
	var flowerBufferRadiusMultiplier = 2.0;
	var tomatoPerStalk = 2;
	var tomatoPlacementTries = 50;

	var entities = [];
	var bee = false;
	var beeAnimator = false;
	var beeTarget = {};
	var beeAnimationBlocked = false;
	var plays = 0;
	var completed = false;

	$scope.flowersPlaced = 0;
	$scope.flowersPollinated = 0;

	// Types of sprites generated in level
	var SpriteTypes = {
		STALK: 	0,
		TOMATO: 1,
		BIRD: 	2,
		FLOWER: 3,
		ROCK:   4,
		BEE:    5
	};

	// The possible scales for each type
	var SpriteScaling = [
		/* STALK  */ {min: 1.0, max: 1.0},
		/* TOMATO */ {min: 0.5, max: 1.0},
		/* BIRD   */ {min: 1.0, max: 1.0},
		/* FLOWER */ {min: 0.8, max: 1.2},
		/* ROCK   */ {min: 0.5, max: 1.0},
		/* BEE    */ {min: 1.0, max: 1.0}
	];

	// The relative origin of the sprite - used for placement
	var SpriteOrigin = [
		/* STALK  */ {x: 0.5, y: 1.0},
		/* TOMATO */ {x: 0.5, y: 0.5},
		/* BIRD   */ {x: 0.5, y: 1.0},
		/* FLOWER */ {x: 0.5, y: 0.5},
		/* ROCK   */ {x: 0.5, y: 1.0},
		/* BEE    */ {x: 0.5, y: 0.5}
	];

	// Templates for each type.
	var SpriteTemplates = [
		/* STALK  */ [],
		/* TOMATO */ [], 
		/* BIRD   */ [], 
		/* FLOWER */ [], 
		/* ROCK   */ [], 
		/* BEE    */ [] 
	];

	// Radius Modifer for each type
	var SpriteRadius = [
		/* STALK  */ 0.00,
		/* TOMATO */ 0.45, 
		/* BIRD   */ 0.35, 
		/* FLOWER */ 0.80,
		/* ROCK   */ 0.45,
		/* BEE    */ 0.25 
	];

	// Placement information by template name
	var SpritePlacement = {
		flowerTemplate: {
			angles: [0, 100],
			offsetX: {min: -10, max: 10}
		},
		redTomatoTemplate: {
			offsetX: {min:-10, max: 0}
		},
		greenTomatoTemplate: {
			offsetX: {min:-10, max: 10},
			pairs: [true, false]
		},
		rockTemplate: {
			offsetY: {min: 10, max: 100}
		},
		stakeATemplate: {
			offsetY: {min: 0, max: 80}
		},
		stakeBTemplate: {
			offsetY: {min: 0, max: 80}
		},
		stakeCTemplate: {
			offsetY: {min: 40, max: 80},
			bird: true
		},
		birdTemplate: {
			offsetX: [45],
			offsetY: [50]
		}
	};

	// Gap between stakes
	var StakeGap = {
		min: 300,
		max: 500
	};

	// Probability of placing rock
	var RockProbability = [
		true, false, false, false
	];

	// Probability of placing a specific stalk
	var StalkProbability = {
		/*stakeATemplate*/ '0': 3,
		/*stakeBTemplate*/ '1': 2,
		/*stakeCTemplate*/ '2': 1
	};

	// A template for a sprite
	function SpriteTemplate(source)
	{
	  this.source = source;
	  this.width = parseInt( source.data('width') );
	  this.height = parseInt( source.data('height') );
	  this.typeName = source.data('type');
	  this.name = source.data('named');
	  this.type = SpriteTypes[ this.typeName ];
	  this.origin = SpriteOrigin[ this.type ];
	  this.scaling = SpriteScaling[ this.type ];
	  this.radius = SpriteRadius[ this.type ];
	  this.placement = SpritePlacement[ this.name ];
	}

	// Populate Templates
	screen._templates.children('[data-type]').each(function()
	{
		var source = $(this);
		var template = new SpriteTemplate( source );

		SpriteTemplates[ template.type ].push( template );
	});

	// Animation when the bee hits a flower
	anim8.save('beeFlowerGrow', {
		keyframe: {
			from: {
				scale: 1,
				easing: 'lasso'
			},
			to: {
				scale: 1.5
			}
		}
	});

	// Animation for tomato when the bee hits it
	anim8.save('beeTomatoDrop', {
		keyframe: {
			'0': 	 { rotate: 0 },
			'10':  { rotate: -45 },
			'20':  { rotate: 45 },
			'30':  { rotate: -30 },
			'40':  { rotate: 30 },
			'50':  { rotate: -15 },
			'60':  { rotate: 15 },
			'70':  { rotate: 0, translateY: 0 },
			'80':  { opacity: 1 },
			'90':  { opacity: 0.8 },
			'100': { opacity: 0, translateY: anim8.scaleValue( 400 ) }
		},
		initial: {
			origin: 'center top'
		}
	});

	// Animation when bee hits rock
	anim8.save('beeHitRock', {
		keyframe: {
			'0': {
				translateY: 0,
				translateX: 0,
				rotate: true
			},
			'10': {
				translateY: anim8.scaleValue( -128 ),
				translateX: anim8.scaleValue( -50 )
			},
			'40': {
				translateX: 0
			},
			'80': {
				translateY: anim8.scaleValue( 12 )
			},
			'90': {
				rotate: 1100
			},
			'100': {
				rotate: 1080,
				translateY: 0
			}
		}
	});

	// Animation when bee hits tomato
	anim8.save('beeHitTomato', {
		keyframe: {
			'0': {
				translateX: true,
				rotate: true
			},
			'40': {
				translateX: anim8.scaleValue( -102 ),
				rotate: -10
			},
			'100': {
				translateX: 0,
				rotate: 0
			}
		}
	}, {
		duration: 1000
	});

	// Animation when bee hits bird
	anim8.save('beeHitBird', {
		keyframe: {
			'0': {
				translateY: 0,
				translateX: 0,
				rotate: true
			},
			'10': {
				translateY: anim8.scaleValue( 256 ),
				translateX: anim8.scaleValue( -50 )
			},
			'40': {
				translateX: 0
			},
			'80': {
				translateY: anim8.scaleValue( -12 )
			},
			'90': {
				rotate: -1100
			},
			'100': {
				rotate: -1080,
				translateY: 0
			}
		}
	}, {
		duration: 2000
	});

	// Animation when bee hits flower
	anim8.save('beeHitFlower', 'tada');

	// Animation for bird when bee hits it
	anim8.save('beeBirdFly', 'bounceOutUp');

	// Animation for scrolling background
	anim8.save('beeBackgroundScroll', {
		keyframe: {
			from: {
				left: 0,
				easing: 'linear'
			},
			to: {
				left: -LevelWidth * 0.5
			}
		}
	});

	// Animation for scroll viewport
	anim8.save('beeViewportScroll', {
		keyframe: {
			from: {
				left: 0,
				easing: 'linear'
			},
			to: {
				left: -LevelWidth
			}
		}
	});

	// Animation for distance marker
	anim8.save('beeDistanceMarkerScroll', {
		keyframe: {
			from: {
				translateX: 0,
				easing: 'linear'
			},
			to: {
				translateX: anim8.scaleValue( markerTravelPercent )
			}
		},
		units: {
			translateX: '%'
		}
	});

	// Animation for clicking on a button
	anim8.save('beeButtonClick', {
		keyframe: {
			'0': {
				scale: 1
			},
			'50': {
				scale: 0.8,
				easing: 'lasso'
			},
			'100': {
				scale: 1
			}
		}
	});

	// Animation when bee misses hole and hits hive
	anim8.save('beeMissedHive', {
		keyframe: {
			'0': {
				translateX: 0,
				translateY: 0,
				rotate: 0
			},
			'10': {
				translateX: anim8.scaleValue( -100 )
			},
			'100': {
				translateX: anim8.scaleValue( -300 ),
				translateY: anim8.scaleValue( 500 ),
				rotate: 720
			}
		},
		units: {
			translateX: '%'
		}
	}, {
		duration: 2000
	});

	// Generates a level (clearing out the previous level beforehand)
	screen.generateLevel = function()
	{
		// Reset Variables
		$scope.flowersPlaced = 0;
		$scope.flowersPollinated = 0;
		entities = [];

		// Empty Viewport
		screen._viewport.children().not('.persistent').remove()
		screen._viewport.restore();
		screen._backgrounds.restore();

		// Probability of a specific stalk
		var stalkProbs = new ProbabilityMap( StalkProbability );

		// Don't let the bird appear in any of the first three stalks
		stalkProbs.buffer( '2', birdOffset );

		// Next X position in world
		var next = Random( StakeGap ) * 2;

		while ( next < LevelWidth )
		{
			// Place a stalk
			var stalkTemplate = SpriteTemplates[ SpriteTypes.STALK ][ stalkProbs.random() ];
			var stalk = new Sprite( stalkTemplate, container, this._viewport );

			stalk.setPosition( next, LevelHeight );
			stalk.add();

			// Place a bird?
			if ( stalkTemplate.placement.bird === true )
			{
				var birdTemplate = Random( SpriteTemplates[ SpriteTypes.BIRD ] );
				var bird = new Sprite( birdTemplate, container, this._viewport );

				bird.setPosition( next, stalk.top );
				bird.add();

				entities.push( bird );
			}
			else
			{
				// Place a flower
				var flowerTemplate = Random( SpriteTemplates[ SpriteTypes.FLOWER ] );
				var flower = new Sprite( flowerTemplate, container, this._viewport );

				if ( stalk.placeChildOn( flower, flowerPlacementTries, LevelHeight ) )
				{
					flower.add();
					$scope.flowersPlaced++;
					entities.push( flower );
				}

				flower.radius *= flowerBufferRadiusMultiplier;

				// Place tomatoes!
				for (i = 0; i < tomatoPerStalk; i++)
				{
					var tomatoTemplate = Random( SpriteTemplates[ SpriteTypes.TOMATO ] );
					var tomato = new Sprite( tomatoTemplate, container, this._viewport );

					if ( stalk.placeChildOn( tomato, tomatoPlacementTries, LevelHeight ) )
					{
						tomato.add();
						entities.push( tomato );

						if ( Random( tomatoTemplate.placement.pairs ) === true )
						{
							var tomato2 = new Sprite( tomatoTemplate, container, this._viewport );
							var changeX = Random( [-1, 1] ) * tomato.radius * 0.5;
							var changeY = Random( [-1, 1] ) * tomato.radius * 0.5;

							tomato2.setPosition( tomato.x - changeX + tomato.radius, tomato.y - changeY );
							tomato.setPosition( tomato.x + changeX + tomato.radius, tomato.y + changeY );

							stalk.children.push( tomato2 );
							entities.push( tomato2 );

							if ( tomato.radius > tomato2.radius )
							{
								tomato2.add();
								tomato.add();
							}
							else
							{
								tomato.add();
								tomato2.add();
							}
						}
					}
				}

				flower.radius /= flowerBufferRadiusMultiplier;
			}

			// Calculate gap before next stalk
			var nextGap = Random( StakeGap );

			// Place a rock?
			if ( Random( RockProbability ) === true )
			{
				var rockTemplate = Random( SpriteTemplates[ SpriteTypes.ROCK ] );
				var rock = new Sprite( rockTemplate, container, this._viewport );
				var rockRange = {
					min: next + rock.radius + stalk.width() * 0.2,
					max: next + nextGap - rock.radius - stalk.width() * 0.2
				};

				// If we can fit a rock here, place it!
				if ( rockRange.min < rockRange.max ) 
				{
					rock.setPosition( Random( rockRange ), LevelHeight );
					rock.add();

					entities.push( rock );
				}
			}

			next += nextGap;
		}

		// If the target number of flowers wasn't placed, try again!
		if ( $scope.flowersPlaced !== FlowersPlacedTarget )
		{
			return screen.generateLevel();
		}

		// Place the bee!
		var beeTemplate = Random( SpriteTemplates[ SpriteTypes.BEE ] );

		bee = new Sprite( beeTemplate, container, this._viewport );
		beeAnimator = bee.animator;
		
		bee.setPosition( beeLeft, (LevelHeight / 2 - bee.radius) * container.getScale() );
		bee.add();

		beeTarget.x = beeLeft;
		beeTarget.y = bee.cy;
		beeAnimator.restore();
		beeAnimator.play({
			initial: {
				translateY: 0,
				translateX: 0,
				rotate: 0
			}
		}, {
			duration: 0
		});

		// Make them global
		window.bee = bee;
		window.beeAnimator = beeAnimator;

		if ( !$scope.$$phase )
		{
			$scope.$apply();
		}
	};

	// Adjusts the bee's position by a value (optionally to a specific value)
	screen.adjustBeePosition = function(by, finalValue)
	{
		beeAnimator.play({
			keyframe: {
				'0': {
					translateY: -by,
					rotate: true,
					easing: 'ease'
				},
				'50': {
					rotate: (by < 0 ? -1 : 1) * Math.min(30, Math.abs( by ) * 0.2)
				},
				'100': {
					translateY: 0,
					rotate: 0
				}
			}	
		}, {
			duration: Math.max( 500, Math.abs( by ) * 7 ) / container.getScale()
		});

		beeAnimator.applyInitialState();

		if (finalValue) {
			beeTarget.y = finalValue;
		} else {
			beeTarget.y += by;	
		}
	};

	// End of the game
	screen.onPlayEnd = function()
	{
		if ( screen.CANCEL )
		{
			return;
		}

		if ( completed )
		{
			if ( $scope.flowersPollinated >= $scope.flowersPlaced * 0.9 )
			{
				CommonFunctions.showHelp( screen._success );	

				SoundEngine.play( 'goal-achieved' );
			}
			else
			{
				CommonFunctions.showHelp( screen._semifail );
			}
		}
		else
		{
			CommonFunctions.showHelp( screen._fail );
		}
	};

	// When the user clicks on the screen adjust the Y offset
	$scope.goToPoint = function(e)
	{
		if ( playing && !beeAnimationBlocked )
		{
			screen.adjustBeePosition( e.offsetY - beeTarget.y - beeAnimator.frame.translateY, e.offsetY );	
		}
	};

	// When the user clicks the UP button...
	$scope.goUp = function()
	{
		if ( playing && !beeAnimationBlocked )
		{
			screen._buttonUp.play('beeButtonClick 200ms');

			screen.adjustBeePosition( -50 + beeAnimator.frame.translateY );	
		}
	};

	// When the user clicks the DOWN button...
	$scope.goDown = function()
	{
		if ( playing && !beeAnimationBlocked )
		{
			screen._buttonDown.play('beeButtonClick 200ms');

			screen.adjustBeePosition( +50 + beeAnimator.frame.translateY );	
		}
	};

	// Start the game!
	$scope.start = function()
	{
		screen.outroduce( 'intro', 'fadeOut', $scope.play );
	};

	// Key Input
  screen.on('introEnd', function()
  {
    Shortcuts.down( { key: Shortcuts.keys.Up }, $scope.goUp );
    Shortcuts.down( { key: Shortcuts.keys.Down }, $scope.goDown );
  });
  screen.on('outroBegin', function()
  {
    Shortcuts.off();
  });


	// Plays the game!
	$scope.play = function()
	{
		if ( playing )
		{
			return;
		}

		if ( plays > 0 )
		{
			screen.generateLevel();
		}
		plays++;

		// Scrolling Items
		var background = screen._backgrounds.animators()[0];
		var viewport = screen._viewport.animators()[0];
		var marker = screen._distanceMarker.animators()[0];
		var calculator = anim8.calculator['2d'];

		var start = anim8.now();
		var nextPollinationTime = 0;
		var checked = false;
		var gravity = 0;
		var gravityVelocity = 0;
		var gravityTerminal = 0;
		var lastTime = start;

		playing = true;
		completed = false;
		beeAnimationBlocked = false;

		SoundEngine.play( 'bee-fly', {loop:-1, volume:0.5} );

		if ( UserProgress.BeeWeight >= 5 && UserProgress.BeeSensor >= 5 )
		{
			gravity = 50;
			gravityTerminal = 300;
		}
		else if ( UserProgress.BeeWeight >= 4 && UserProgress.BeeSensor >= 4 )
		{
			gravity = 25;
			gravityTerminal = 50;
		}

		var run = function()
		{
			var time = anim8.now();
			var duration = (time - start) * 0.001;
			var scrollDelta = Math.min( duration / scrollTime, 1.0 );
			var scrollProgress = LevelWidth * scrollDelta;
			var maxDelta = Math.min( duration / maxTime, 1.0 );
			var dt = (time - lastTime) * 0.001;
			lastTime = time;

			// Scrolling Items
			viewport.set({
				left: -scrollProgress * container.getScale()
			});
			background.set({
				left: -scrollProgress * backgroundParralaxAmount * container.getScale()
			});
			marker.set({
				translateX: (markerTravelPercent * maxDelta) + '%'
			});

			// Bee position
			beeTarget.x = ( LevelWidth * (duration / scrollTime) + beeLeft );
			beeTarget.y += ( gravityVelocity = Math.min( gravityTerminal, gravityVelocity + gravity * dt ) ) * dt;

			beeAnimator.set({
				center: {
					x: beeTarget.x * container.getScale(),
					y: beeTarget.y
				}
			});
			bee.setCenter(
				beeTarget.x + beeAnimator.frame.translateX, 
				(beeTarget.y + beeAnimator.frame.translateY) / container.getScale()
			);

			// Bee animation blocked?
			beeAnimationBlocked = (duration < nextPollinationTime);

			// Check for intersections

			var intersected = false;
		
			for (var i = 0; i < entities.length; i++)
			{
				var obs = entities[i];

				if ( !obs.inactive && obs.intersects( bee ) )
				{
					obs.inactive = true;

					switch (obs.template.type)
					{
						case SpriteTypes.TOMATO:								
							obs.element.play('beeTomatoDrop');
							bee.element.play('beeHitTomato');
							nextPollinationTime = duration + 1;
							intersected = true;
							SoundEngine.play( 'bee-collision' );
							break;
						case SpriteTypes.ROCK:
							bee.element.play('beeHitRock 3s');
							nextPollinationTime = duration + 3;
							intersected = true;
							SoundEngine.play( 'bee-ground' );
							break;
						case SpriteTypes.FLOWER:
							if ( !beeAnimationBlocked && UserProgress.BeeCanPollinate )
							{
								obs.element.play('beeFlowerGrow');
								bee.element.play('beeHitFlower');	
								intersected = true;
								$scope.flowersPollinated++;

								if ( !$scope.$$phase )
								{
									$scope.$apply();
								}

								screen._pollinated.play('pulse');
							}
							SoundEngine.play( 'goal-achieved', {volume:0.05} );
							break;
						case SpriteTypes.BIRD:
							obs.element.play('beeBirdFly 2s');
							bee.element.play('beeHitBird 3s');
							nextPollinationTime = duration + 3;
							intersected = true;
							SoundEngine.play( 'bird-hit' );
							break;
					}

				}
			}

			if ( intersected )
			{
					beeAnimator.applyInitialState();
			}

			// Bee animation blocked?
			beeAnimationBlocked = (duration < nextPollinationTime);

			// Check whether we've entered the beehive?
			if ( duration > checkTime && !checked )
			{
				var beeTop = bee.cy - bee.radius;
				var beeBottom = bee.cy + bee.radius;

				if ( beeTop >= checkWindow.top && beeBottom <= checkWindow.bottom )
				{
					beeAnimator.play('tada');
					completed = true;
				}
				else
				{
					beeAnimator.play('beeMissedHive');
				}

				beeAnimationBlocked = true;
				nextPollinationTime = maxTime;
				checked = true;
			}

			// Has the bee failed?
			var failed = false;

			// If the bee is half off the bottom of the screen, we've crashed!
			if ( bee.cy >= 450 )
			{
				failed = true;
			}

			// While time is not up OR the user has not left the screen... play more!
			if ( duration < maxTime && !screen.CANCEL && !failed )
			{
				anim8.requestRun( run );
			}
			else
			{
				playing = false;

				SoundEngine.stopAll();

				screen.onPlayEnd();
			}
		};

		// Start!
		anim8.requestRun( run );
	};

	// Used to display power dots
	$scope.hasPower = function(power)
	{
		return UserProgress.BeePower >= power;
	};

	// Used to display power dots
	$scope.hasWeight = function(weight)
	{
		return UserProgress.BeeWeight >= weight;
	};

	// Used to display power dots
	$scope.hasSensor = function(sensor)
	{
		return UserProgress.BeeSensor >= sensor;
	};

	// Try playing again!
	$scope.tryAgain = function(currentDialog)
	{
		CommonFunctions.hideHelp( screen.sprite( currentDialog ), $scope.play );
	};

	// Rebuild your Bee!
	$scope.rebuild = function()
	{
		manager.transition( 'level3_build' );
	};

	// The image used for the dots.
	$scope.dot = 'dot';

	screen.updateDotImage = function()
	{
		if ( UserProgress.BeeWeight >= 5 && UserProgress.BeeSensor >= 5 )
		{
			$scope.dot = 'dot_red';
		}
		else if ( UserProgress.BeeWeight >= 4 && UserProgress.BeeSensor >= 4 )
		{
			$scope.dot = 'dot_yellow';
		}
		else
		{
			$scope.dot = 'dot';
		}
	};

	// When they try to leave the screen, cancel the game.
	screen.on('outroBegin', function()
	{
		screen.CANCEL = true;
	});

	// Everytime the screen is introduced...
	screen.on('introBegin', function()
	{
		plays = 0;
		completed = false;
		beeAnimationBlocked = false;

		screen.generateLevel();

		screen.updateDotImage();

		if ( !$scope.$$phase )
		{
			$scope.$apply();
		}
	});

	// Reset Dialogs
	screen.on('introBefore', function()
	{
		screen.CANCEL = false;
		screen._intro.removeClass( 'hidden' );
		screen._fail.addClass( 'hidden' );
		screen._semifail.addClass( 'hidden' );
		screen._success.addClass( 'hidden' );
	});

	// The next screen is the reward screen
	$scope.next = function()
	{
		manager.transition('level3_reward');
	};

	// The previous screen is the build screen
	$scope.prev = function()
	{
		manager.transition( 'level3_build' );
	};
	
}]);